import React from 'react'
import { Dialog, DialogContent, Fade, Typography, Paper, Grid, DialogActions } from '@material-ui/core'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { SoleUser } from 'assets'
import { Button } from 'dls/atoms/Button'
import { ColorType } from 'dls/shared/types'

interface OwnProps {
  open: boolean
  setOpen?: (open: boolean) => void
}

const Title = styled(Typography)`
  margin-bottom: 24px;
`

const Description = styled(Typography)`
  margin-bottom: 16px;
`

const StyledButton = styled(Button)`
  width: 154px;
  margin-right: 24px;
  margin-bottom: 24px;
`

const DialogContentContainer = styled(Typography)`
  text-align: center;
  padding-top: 48px;
  padding-bottom: 0px;
`

const NoSetUpUserForReviewDialog = (props: OwnProps) => {
  const { t } = useTranslation()
  return (
    <Dialog
      open={props.open}
      scroll="paper"
      onClose={() => props.setOpen && props.setOpen(false)}
      TransitionComponent={Fade}
      fullWidth
      PaperComponent={Paper}
      maxWidth="sm"
    >
      <DialogContent>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <DialogContentContainer variantMapping={{ body1: 'div' }}>
            <img src={SoleUser} alt="Sole User" />
            <Title variant="h5">{t('It looks like you’re the sole user')}</Title>
            <Description variant="body2">
              {t(
                'You need at least 1 other colleague with Bank Manager access in order to use the governance approval process. Colleagues can be given access via your own user management process. '
              )}
            </Description>
          </DialogContentContainer>
        </Grid>
      </DialogContent>
      <DialogActions>
        <StyledButton
          disabled={false}
          onClick={() => props.setOpen && props.setOpen(false)}
          color={ColorType.BUTTON}
          variant="contained"
        >
          {t('Go Back')}
        </StyledButton>
      </DialogActions>
    </Dialog>
  )
}
export default NoSetUpUserForReviewDialog
